import { render, staticRenderFns } from "./ProgressDonut.vue?vue&type=template&id=0f5175d2&scoped=true&"
import script from "./ProgressDonut.vue?vue&type=script&lang=ts&"
export * from "./ProgressDonut.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressDonut.vue?vue&type=style&index=0&id=0f5175d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5175d2",
  null
  
)

export default component.exports